<template>
  <div id="g-signin-button"></div>
</template>
 
<script>
import jwt_decode from "jwt-decode";
export default {
  data() {
    return {
      /**
       * The Auth2 parameters, as seen on
       * https://developers.google.com/identity/sign-in/web/reference#gapiauth2initparams.
       * As the very least, a valid client_id must present.
       * @type {Object}
       */
      googleSignInParams: {
        client_id:process.env.VUE_APP_GOOGLE_CLIENT_ID
        //   "99834882590-jd0fibi5qkfrc8qb144pe6bkot3uoc3j.apps.googleusercontent.com",
        // // "1094586243626-8hfl1fmvrfu6u1obhtdp3k6g787im6kd.apps.googleusercontent.com", // For prod
      },
    };
  },
  created() {
    let googleScript = document.createElement("script");
    googleScript.setAttribute("src", "https://accounts.google.com/gsi/client");
    googleScript.async = true;
    googleScript.defer = true;
    document.head.appendChild(googleScript);
    googleScript.onload = () => {
      window.google.accounts.id.initialize({
        client_id: this.googleSignInParams.client_id,
        callback: this.onSignInSuccess,
      });
      window.google.accounts.id.prompt();
      let parentDiv = document.getElementById("g-signin-button");
      window.google.accounts.id.renderButton(parentDiv, {});
    };
  },
  methods: {
    onSignInSuccess(response) {
      // `googleUser` is the GoogleUser object that represents the just-signed-in user.
      // See https://developers.google.com/identity/sign-in/web/reference#users
      // const profile = googleUser.getBasicProfile() // etc etc
      let decoded = jwt_decode(response.credential);
      this.$emit("onSignIn", { user: decoded, jwt: response.credential });
    },
    onSignInError(error) {
      // `error` contains any error occurred.
      console.log("OH NOES", error);
    },
  },
};
</script> 
 
<style>
.g-signin-button {
  /* This is where you control how the button looks. Be creative! */
  display: inline-block;
  padding: 4px 8px;
  border-radius: 3px;
  background-color: #3c82f7;
  color: #fff;
  box-shadow: 0 3px 0 #0f69ff;
}
</style>
